import { combineReducers } from 'redux';
import topLevelcategoryIds, { initialState as topLevelcategoryIdsInitialState, } from './topLevelcategoryIds';
import categoryCache, { initialState as categoryCacheInitialState, } from './categoryCache';
import articleCache, { initialState as articleCacheInitialState, } from './articleCache';
import articleFullCache, { initialState as articleFullCacheInitialState, } from './articleFullCache';
import meta, { initialState as metaInitialState, } from './meta';
export const initialState = {
    meta: metaInitialState,
    topLevelcategoryIds: topLevelcategoryIdsInitialState,
    categoryCache: categoryCacheInitialState,
    articleCache: articleCacheInitialState,
    articleFullCache: articleFullCacheInitialState,
};
const reducer = combineReducers({
    meta,
    topLevelcategoryIds,
    categoryCache,
    articleCache,
    articleFullCache,
});
export default reducer;
//# sourceMappingURL=index.js.map